import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}

	let arr = []

	const hasMajorDisease = !(
		injured.majorDisease &&
		['0', ''].includes(injured.majorDisease.hasMajorDisease)
	)

	if (hasMajorDisease) {
		let list = [{}]
		if (injured.majorDisease && injured.majorDisease.majorDiseaseList.length) {
			list = injured.majorDisease.majorDiseaseList
		}

		for (const item of list) {
			let majorDiseaseInfoArr = []
			majorDiseaseInfoArr.push(
				{
					label: '重疾种类',
					value: item.diseaseTypeDesc,
				},
				{
					label: '重疾描述',
					value: item.diseaseDesc,
				},
				{
					label: '确诊依据',
					value: item.diagnosisBasisDesc,
				},
				{
					label: '确诊时间',
					value: formatDate(item.diagnosisDate),
				},
				{
					label: '原发部位',
					value: setting.primarysiteMap[item.primarySite],
				},
				{
					label: '原发部位描述',
					value: item.primarySiteDesc,
				}
			)
			arr.push(majorDiseaseInfoArr)
		}
	}

	const obj = {
		title: '重疾信息',
		children: arr,
		show: {
			hasMajorDisease,
		},
	}

	return obj
}
